export const DATA_NOT_FOUND = 'n/a';
export const DASH_DASH = '--';
